import {
  Button,
  Div,
  H3,
  Modal,
  ModalIconStyle,
  P,
  PropsModal,
  SuccessToast,
  TrashIcon,
  deleteClosingDay,
  reportError,
} from '@vgrubs/components';
import { BrandClosingDayEntity } from 'components/src/types/location.types';
import { Dispatch, SetStateAction } from 'react';

export const ClosingDaysDelete = ({
  setLoading,
  modalIsOpen,
  closeModal,
  setClosingDays,
}: PropsModal & {
  setLoading: Dispatch<SetStateAction<boolean>>;
  modalIsOpen: BrandClosingDayEntity | null;
  setClosingDays: Dispatch<SetStateAction<BrandClosingDayEntity[]>>;
}) => {
  const day = modalIsOpen;

  async function handleDeleteClosingDate() {
    if (!day) return;
    try {
      setLoading(true);
      const { data } = await deleteClosingDay(day.id);
      setClosingDays((prev) => {
        const filtered = prev.filter((d) => d.id !== day.id);
        return filtered;
      });
      SuccessToast(data.message);
      closeModal?.();
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={!!modalIsOpen} closeModal={closeModal} logo={false}>
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <TrashIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Delete Closing Day?</H3>
      <P $mb="16">
        Are you sure you want to delete this day from closing days list?
      </P>

      <Div $flex $gap="20px">
        <Div $width="50%">
          <Button
            $selected
            $w="100%"
            $mt="24"
            onClick={handleDeleteClosingDate}
          >
            Yes
          </Button>
        </Div>
        <Div $width="50%">
          <Button
            $selected
            $gray
            $w="100%"
            $mt="24"
            onClick={() => closeModal?.()}
          >
            No
          </Button>
        </Div>
      </Div>
    </Modal>
  );
};
